<template>
  <FormFieldWrapper :data="data">
    <div class="multi-selection-container">
      <VACheckbox
        v-for="(option, index) in options"
        :key="index"
        :status="isChecked(option) ? 'checked' : 'uncheck'"
        :label="option"
        color="dark-blue"
        @changeStatus="handleChange(option, $event)"
      />
    </div>
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'MultiSelection',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    options() {
      return this.data?.options || [];
    }
  },
  emits: ['update:modelValue'],
  methods: {
    isChecked(option) {
      return this.modelValue.includes(option);
    },
    handleChange(option, status) {
      const newValue = [...this.modelValue];
      if (status === 'checked') {
        if (!newValue.includes(option)) {
          newValue.push(option);
        }
      } else {
        const index = newValue.indexOf(option);
        if (index > -1) {
          newValue.splice(index, 1);
        }
      }
      this.$emit('update:modelValue', newValue);
    }
  }
};
</script>

<style scoped>
.multi-selection-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
